<script>
export default {
    
}
</script>

<template>
    <div>
        <div id="page-content">
            <slot />
        </div>
    </div>
</template>
